import { createContext } from 'react';
import { createStore, StoreApi } from 'zustand';
import { ClientAuthenticationSession, defaultSessionCookie } from './types';

export type AuthSessionStore = StoreApi<ClientAuthenticationSession>;

export const createSessionStore = (
  session?: ClientAuthenticationSession,
): AuthSessionStore =>
  createStore<ClientAuthenticationSession>(
    () => session || defaultSessionCookie,
  );

export const AuthSessionContext = createContext<AuthSessionStore | null>(null);
